﻿import './style.scss'
import './highlight'

class Search {
    constructor(element) {
        this.element = element;
    }
    init() {

        window.addEventListener('DOMContentLoaded', (event) => {
            const elem = this.element;

            if (typeof (PagefindUI) === 'undefined') {
                document.getElementById(elem).innerHTML = '<span class="text-danger"><i class="fa fa-exclamation mr-1  mt-1" aria-hidden="true"></i> execute "<i>npm run index</i>"&nbsp;to populate search</span>';
                return;
            }

            const publication = document.querySelector('meta[name="publication"]').getAttribute('content');

            new PagefindUI({
                element: "#" + elem,
                highlightParam: "highlight",
                excerptLength: 60,
                showEmptyFilters: true,
                showImages: false,
                showSubResults: true,
                resetStyles: true,
                //debounceTimeoutMs: 500,
                translations: {
                    placeholder: `Search in the ${publication} Newsletter...`,
                    zero_results: "Couldn't find [SEARCH_TERM]"
                },
                processResult: function (result) {
                    result.url = result.url.replace('/assets', '');
                    result.sub_results.forEach((item) => {
                        item.url = item.url.replace('/assets', '');
                    });
                    return result;
                }
            });

            this.#waitForElm('.pagefind-ui__search-input').then((elm) => {
                elm.addEventListener('focus', function () {
                    elm.style.width = "-webkit-fill-available";
                })

                elm.addEventListener('blur', function () {
                    setTimeout(function () {
                        //document.getElementById(elem).style.width = "initial";
                        //elm.style.width = "initial";
                    }, 200); // Adjust the delay as needed
                    return true;
                }, false);
            });

            new PagefindHighlight({ highlightParam: "highlight", markContext: "#main-content" });

            const params = new URLSearchParams(window.location.search);
            const highlight = params.get('highlight');

            if (highlight !== null) {
                const searchElem = document.querySelector('.pagefind-ui__search-input');

                searchElem.value = highlight;
                searchElem.focus();

                const clearElem = document.querySelector('.pagefind-ui__search-clear');
                clearElem.classList.remove('pagefind-ui__suppressed');

                clearElem.addEventListener('click', function (e) {
                    searchElem.value = "";
                    e.target.classList.add('pagefind-ui__suppressed');
                    history.replaceState("", document.title, window.location.pathname);
                    document.querySelectorAll('mark').forEach((elem) => {
                        elem.classList.remove('pagefind-highlight');
                        elem.style.backgroundColor = 'initial';
                    });
                });
            }
        });
    }

    #waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }
}

export default Search